"use client";

import React from "react";

import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {PortableTextBlock} from "sanity";
import {richTextComponent} from "@/sanity/sanityPortableText";
import FAQList from "@/components/global/ui/FAQList";
import {CTACornerButton} from "@/shadcn/ui/corner-button";
import {GROQCornerButton} from "@/sanity/lib/definitions";

export default function FAQSection({
  text,
  items,
  cta,
  className,
}: {
  text?: PortableTextBlock[];
  items: {
    question: string;
    answer: PortableTextBlock[];
  }[];
  cta?: GROQCornerButton
  className?: string;
}) {
  return (
    <section className={cn(
      "overflow-clip bg-[#0A1A1D] relative z-10",
      className
    )}>
      <div className="container">
        <div className="w-[min(187.5rem,100%)] mx-auto flex flex-col items-center">
          <div className="flex flex-col items-center gap-[4rem]">
            {text && (
              <div className="richtext prose-headings:tracking-[.15rem] richtext-center prose-headings:text-[6rem] lg:prose-headings:text-[7rem] prose-headings:font-ivy prose-headings:text-white prose-headings:mb-[2rem] prose-p:text-white/60 prose-strong:font-light prose-strong:text-white prose-p:mb-[2rem] prose-p:text-[2.25rem] w-[90%] lg:w-[84.625rem]">
                <PortableText
                  value={text}
                  components={richTextComponent}
                />
              </div>
            )}

            {items && (
              <FAQList
                className="w-[min(108.75rem,100%)] [&_img]:invert prose-h3:font-normal prose-h3:text-white prose-p:text-white/60 prose-p:font-light [&_.faq-item]:bg-[#112628]"
                faq={items}
              />
            )}

            {cta && (
              <CTACornerButton
                className="[&_button]:!text-[2rem] lg:[&_button]:!text-[2.25rem]"
                data={cta}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
